export interface AboutData {
  intro: string;
  frontendSkills: string[];
  backendSkills: string[];
  highlights: string[];
}

export const aboutData: AboutData = {
  intro:
    "Tech Lead / Senior Software Developer with **5+ years** of experience in React Native, Node.js, and .NET development. Proven expertise in building high-performance systems, leading Dev teams, and delivering scalable solutions for both startups and enterprises.",
  frontendSkills: [
    "React Native (JS/TS)",
    "Native Modules (Swift/Kotlin)",
    "React.js (MUI)",
    "Deep Linking",
    "OTA Update (CodePush)",
    "Figma / UI-UX",
  ],
  backendSkills: [
    "Node.js",
    "NestJS",
    ".NET",
    "MySQL",
    "SQL Server",
    "MongoDB",
    "Redis",
    "Firebase",
    "RabbitMQ",
  ],
  highlights: [
    "5+ years of React Native, Node.js & .NET experience",
    "Led architecture and delivery of large-scale e-commerce platforms",
    "Expertise in microservices, caching, and event-driven systems",
    "Strong leadership: task allocation, code review, project estimation",
  ],
};
